/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{min-width:0;width:90%;padding-left:10%;padding-top:10%;text-align:center;min-width:0}@media (max-width:750px){.container[_ngcontent-%COMP%]{min-width:0;width:100%;padding:5%;min-width:0}}img[_ngcontent-%COMP%]{border-radius:50px;margin-bottom:20px;max-width:50%}.heading[_ngcontent-%COMP%]{font-size:2rem;font-family:Montserrat;margin-top:0;margin-bottom:1rem}[_nghost-%COMP%]     .heading b{font-weight:800}p.text[_ngcontent-%COMP%]{font-size:1rem;font-family:Montserrat}"];
export { styles as styles };
